import "../footer-modal.scss";
import "../../../../scss/common.scss";

const CookiesPolicy = () => {
  return (
      <div className="modalContent">
        <p className="label-color fs-18">
          This cookie policy ("Policy") describes what cookies are and how and
          they're being used by the Pay PCN website ("Website" or "Service") and
          any of its related products and services (collectively, "Services").
          This Policy is a legally binding agreement between you ("User", "you"
          or "your") and this Website operator ("Operator", "we", "us" or
          "our"). You should read this Policy so you can understand the types of
          cookies we use, the information we collect using cookies and how that
          information is used. It also describes the choices available to you
          regarding accepting or declining the use of cookies. For further
          information on how we use, store and keep your personal data secure,
          see our privacy policy. This cookie policy was created with the help
          of the cookie policy generator.
        </p>
        <br></br>
        <h2 className="label-color fs-22">What are cookies?</h2>
        <p className="label-color fs-18">
          Cookies are small pieces of data stored in text files that are saved
          on your computer or other devices when websites are loaded in a
          browser. They are widely used to remember you and your preferences,
          either for a single visit (through a "session cookie") or for multiple
          repeat visits (using a "persistent cookie").<br></br>
          <br></br>
          Session cookies are temporary cookies that are used during the course
          of your visit to the Website, and they expire when you close the web
          browser.<br></br>
          <br></br> Persistent cookies are used to remember your preferences
          within our Website and remain on your desktop or mobile device even
          after you close your browser or restart your computer. They ensure a
          consistent and efficient experience for you while visiting the Website
          and Services.<br></br>
          <br></br>
          Cookies may be set by the Website ("first-party cookies"), or by third
          parties, such as those who serve content or provide advertising or
          analytics services on the Website ("third party cookies"). These third
          parties can recognize you when you visit our website and also when you
          visit certain other websites.
        </p>
        <h2>What type of cookies do we use?</h2>
        <h3 className="fs-18 label-color fw-600">
          Necessary cookies:{" "}
          <span className="selected-field-color fs-18 cookiesListText">
            Necessary cookies allow us to offer you the best possible experience
            when accessing and navigating through our website and using its
            features. For example, these cookies let us recognize that you have
            created an account and have logged into that account to access the
            content.
          </span>
        </h3>
        <h3 className="fs-18 label-color fw-600">
          Analytical cookies:{" "}
          <span className="selected-field-color fs-18 cookiesListText">
            Functionality cookies let us operate the Website and Services in
            accordance with the choices you make. For example, we will recognize
            your username and remember how you customized the Website and
            Services during future visits.
          </span>
        </h3>
        <h3 className="fs-18 label-color fw-600">
          {" "}
          Functionality cookies:{" "}
          <span className="selected-field-color fs-18 cookiesListText">
            These cookies enable us and third-party services to collect
            aggregated data for statistical purposes on how our visitors use the
            Website. These cookies do not contain personal information such as
            names and email addresses and are used to help us improve your user
            experience of the Website.
          </span>
        </h3>
        <h3 className="fs-18 label-color fw-600">
          Social media cookies:{" "}
          <span className="selected-field-color fs-18 cookiesListText">
            Third party cookies from social media sites (such as Facebook,
            Twitter, etc) let us track social network users when they visit or
            use the Website and Services, or share content, by using a tagging
            mechanism provided by those social networks.
          </span>
        </h3>
        <p className="label-color fs-18">
          These cookies are also used for event tracking and remarketing
          purposes. Any data collected with these tags will be used in
          accordance with our and social networks' privacy policies. We will not
          collect or share any personally identifiable information from the
          user.
        </p>

        <h2>What are your cookie options?</h2>
        <p className="label-color fs-18">
          If you don't like the idea of cookies or certain types of cookies, you
          can change your browser's settings to delete cookies that have already
          been set and to not accept new cookies. To learn more about how to do
          this, visit All You Need to Know About Internet Cookies & Your
          Security
        </p>

        <h2>Changes and amendments</h2>
        <p className="label-color fs-18">
          We reserve the right to modify this Policy or its terms relating to
          the Website and Services at any time, effective upon posting of an
          updated version of this Policy on the Website. When we do, we will
          revise the updated date at the bottom of this page. Continued use of
          the Website and Services after any such changes shall constitute your
          consent to such changes.
        </p>

        <h2>Acceptance of this policy</h2>
        <p className="label-color fs-18">
          You acknowledge that you have read this Policy and agree to all its
          terms and conditions. By accessing and using the Website and Services
          you agree to be bound by this Policy. If you do not agree to abide by
          the terms of this Policy, you are not authorized to access or use the
          Website and Services.
        </p>
      </div>
  );
};

export default CookiesPolicy;
